import { FC } from 'react';
import { Provider } from 'react-redux';
import { globalStore } from 'reduxStore';

export const StoreProvider: FC = ({ children }) => {
  return <Provider store={globalStore}>{children}</Provider>;
};
